import forage from 'localforage'

export const fProgram = forage.createInstance({
  name: 'crms-table',
  storeName: 'fso',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setClusters = clusters => {
  return fProgram.setItem('clusters', clusters)
}

const getClusters = async () => {
  return await fProgram.getItem('clusters')
}

export {
  setClusters,
  getClusters
}
